import axios from 'axios';
import { BASE_PATH_API } from 'constants/env';
import {
  transformListParams,
  transformListRes,
} from 'services/commons/transformers';
import { transformReviews, transformStats } from './transformers';

export function getReviews(params = {}) {
  const transformedParams = transformListParams(params);

  return axios({
    url: `${BASE_PATH_API}/gift-table/v1/review`,
    params: transformedParams,
  })
    .then((res) => res)
    .then((res) => {
      const { data, pagination } = res.data;

      const transformedReviews = transformReviews(data.items);
      const listResponse = transformListRes(transformedReviews, pagination);

      const transformedStats = transformStats(data.stats);

      return [listResponse, transformedStats];
    });
}
